import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { allowNumberOnly } from '../../../utils/common';
import trashIcon from '../../../assets/images/delete_icon_red.png';
import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage,
	getFromLocalStorage,
	setToLocalStorage,
} from '../../../utils/StorageUtils';
import {
	validateFieldValue,
} from '../../SearchPanel/formUtils';
import MultiplePetItem from './multiplePets';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import {
	AUTOCOMPLETE_TYPE,
	DIMENSION_UNIT,
	FORM_FIELDS,
	FRESH_FORWARD_PRODUCT,
	getInitLooseItemDetail,
	getInitPharmaObject,
	getInitULDItemDetail,
	PHARMA_PRODUCT,
	PHARMA_SHIPPING_TYPE,
	IS_KNOWN_UNKNOWN,
	PRICE_CODE_TYPE,
	SCC_CODES,
	SHIPPING_TYPE,
	VALIDATE_BOOKINGS_ERROR_CODES,
	WEIGHT_UNIT,
	NOTIFICATION_MESSAGE_TYPE,
	SYSTEM_ADDED_SCCS,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
	getInitPetDetail,
	WEIGHT_UNIT_SELECT_ITEMS,
	DIMENSION_UNIT_SELECT_ITEMS,
} from '../../../constants'
import MESSAGES from '../../../constants/Messages'
import CommonInput from '../../../common/Resusable/CommonInput';
import { Divider } from '../../../common/Divider';
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown';

const Cages = ({
	shippingItem,
	// petList,
	// setPetList,
	error,
	setError,
	file,
	setFile,
	dogBreeds,
	searchFormData,
	setArrayListDoc,
	arrayListDoc,
	petOrder,
	setCageList,
	cageList,
	//cageIndex,
	//handleCageItemChange,
	//item,
	setDeletedCageIds,
	deletedCageIds,
	setDeletedPetIds,
	deletedPetIds,
	weightUnit,
	dimensionUnit,
	setDimensionUnit,
	setWeightUnit,
	breedRejected,
	setBreedRejected,
}) => {

	const { t, i18n } = useTranslation(['labels', 'errors'])
	const [alertProps, setAlertProps] = useState({})
	const [stubNose, setStubNose] = useState('')
	const [weight, setWeight] = useState()
	const [length, setLength] = useState()
	const [width, setWidth] = useState()
	const [height, setHeight] = useState()
	//const [weightUnit, setWeightUnit] = useState('K');
	const [measurement, setMeasurement] = useState('C');
	const [pieces, setPieces] = useState(1);
	const [id, setId] = useState(0);
	const [cageOrder, setCageOrder] = useState();
	const [sccWarning, setSccWarning] = useState(null);
	// const [pets, setPetList] = useState(

	// 		[getInitPetDetail()]
	// )



	// useEffect(() => {
	// 	console.log("use-effect : handleCageItemChange");
	// 	handleCageItemChange(cageIndex, {
	// 		weight,
	// 		length,
	// 		width,
	// 		height,
	// 		weightUnit,
	// 		measurement,
	// 		pieces,
	// 		pets,
	// 		id,
	// 		cageOrder,
	// 	})
	// }, [
	// 	weight,
	// 	length,
	// 	width,
	// 	height,
	// 	weightUnit,
	// 	measurement,
	// 	pieces,
	// 	pets,
	// 	id,
	// ])

	const handleErrorFields = (key, errorCode) => {
		const tempError = error ? { ...error } : null
		if (tempError && tempError[key]) {
			let errorArr = tempError[key] ? [...tempError[key]] : []
			let filteredArr = errorArr.map((item) => item ? item : null)
			if (!filteredArr.includes(errorCode)) {
				tempError[key] = null
				setError(tempError)
			}
		}
	}

	useEffect(() => {
		//handleErrorFields(FORM_FIELDS.CRATE_TOTAL_WEIGHT, 'ER245')
		//handleErrorFields(FORM_FIELDS.CRATE_LENGTH, 'ER246')
		//handleErrorFields(FORM_FIELDS.CRATE_WIDTH, 'ER247')
		//handleErrorFields(FORM_FIELDS.CRATE_HEIGHT, 'ER248')
	}, [error])

	const clearError = (key, index) => {
		const tempError = error ? { ...error } : null
		if (
			tempError &&
			tempError[FORM_FIELDS.CAGE_ITEMS] &&
			tempError[FORM_FIELDS.CAGE_ITEMS][index]
		) {
			tempError[FORM_FIELDS.CAGE_ITEMS][index][key] = null
			setError(tempError)
		}
	}

	const handleError = (key, errorMsg, index) => {
		const tempError = error ? { ...error } : {}
		let cageErrors =
			error && error[FORM_FIELDS.CAGE_ITEMS]
				? error[FORM_FIELDS.CAGE_ITEMS]
				: []
		if (cageErrors) {
			cageErrors[index] = cageErrors[index]
				? { ...cageErrors[index], [key]: errorMsg }
				: { [key]: errorMsg }
			setError({ ...error, [FORM_FIELDS.CAGE_ITEMS]: cageErrors })
		}
	}



	const handleCageItemChange = (key, item, index) => {
		const cageListJson = getFromSessionStorage('cageList')

		if (cageListJson) {
			const cageListData = JSON.parse(cageListJson)
			cageListData[index][key] = item
			setCageList([...cageListData])
		}
	}

	const setPetList = (petsListNew, index) => {
		handleCageItemChange('pets', petsListNew, index)
	}



	const handleRemoveItem = (indexPassed, item) => {
		if (item.id) {
			let idObj = {
				'id': indexPassed
			}
			setDeletedCageIds([...deletedCageIds, idObj]);
		}

		const itemsTemp = [...cageList].filter((itemDetail, curr) => {
			return item.id ? itemDetail.id !== indexPassed : indexPassed !== curr
		})
		setCageList([...itemsTemp])
	}


	return (
		<>
			{
				cageList.map((item, cageIndex) => {
					const lengthError =
						error &&
							error[FORM_FIELDS.CAGE_ITEMS] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_LENGTH]
							? error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_LENGTH]
							: null
					const widthError =
						error &&
							error[FORM_FIELDS.CAGE_ITEMS] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_WIDTH]
							? error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_WIDTH]
							: null
					const heightError =
						error &&
							error[FORM_FIELDS.CAGE_ITEMS] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_HEIGHT]
							? error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_HEIGHT]
							: null
					const weightError =
						error &&
							error[FORM_FIELDS.CAGE_ITEMS] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex] &&
							error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_TOTAL_WEIGHT]
							? error[FORM_FIELDS.CAGE_ITEMS][cageIndex][FORM_FIELDS.CRATE_TOTAL_WEIGHT]
							: null
					return (
						<div className='cargo-pet-container-row' key={cageIndex}>
							<div className='cage-header'>
								<label className="cage-label">{
									`${t('COMMON.CONTAINER_COUNT', {
										index: cageIndex + 1,
									})}`
								}
								</label>

								{cageList.length > 1 ? (
									<div className='delete-section' onClick={() => handleRemoveItem(item.id ? item.id : cageIndex, item)}>
										<img
											src={trashIcon}

											alt='Trash'
											title='Trash'
										/>
										<span>{t('BOOKING.REMOVE_CNTR')}</span>
									</div>
								) : (
									<></>
								)}
							</div>
							<div className='cage-dimensions-section'>
								<div
									className='top-block'
								>
									<div className={`form-group input-with-dropdown `}>
										<CommonInput
											type='text'
											className=''
											label={t('COMMON.TOTAL_WT')}
											value={item.weight <= 0 ? "" : item.weight}
											onKeyDown={(evt) => allowNumberOnly(evt)}
											onChange={(e) => {

												if (
													e.target.value.length <= 9 &&
													(!e.target.value.split('.')[1] ||
														!e.target.value.split('.')[1].length ||
														e.target.value.split('.')[1].length < 2) &&
													e.target.value.split('.').length <= 2
												)

													setWeight(Number(e.target.value))
												handleCageItemChange('weight', Number(e.target.value), cageIndex)
											}}
											onFocus={(e) => {
												clearError(FORM_FIELDS.CRATE_TOTAL_WEIGHT, cageIndex)
											}}
											onBlur={(e) => {
												//error[FORM_FIELDS.CRATE_TOTAL_WEIGHT] = validateFieldValue(e.target.value)
												let errorMsg = validateFieldValue(e.target.value, t(MESSAGES.VALID_TOTAL_WEIGHT))
												if (errorMsg) {
													handleError([FORM_FIELDS.CRATE_TOTAL_WEIGHT], errorMsg, cageIndex)
												}
											}}
											error={weightError ? t(weightError, { ns: 'errors' }) : ''}
										/>
										<CommonDropDown
											id="cage-weight-unit-dropdown"
											disabled={cageIndex > 0 ? true : false}
											value={weightUnit}
											options={WEIGHT_UNIT_SELECT_ITEMS}
											onChange={async (e) => {
												// setDisableButton && setDisableButton(false)
												setToLocalStorage("weight", e.target.value)
												setWeightUnit(e.target.value);
												handleCageItemChange('weightUnit', e.target.value, cageIndex)
												// draftCallback(true)
											}}
											error={weightError}
											isNoLabel
										/>
									</div>
									<label className="cage-weight-label">{
										`${t('COMMON.CONTAINER_WEIGHT_LABEL', {
											index: cageIndex + 1,
										})}`
									}</label>
								</div>
								<div
									className={`bottom-block`}
								>
									<div className='bottom-block-top'>
										<div className='form-group'>
											<CommonInput
												type='text'
												label={t('COMMON.LN')}
												value={item.length === 0 ? '' : item.length}
												onKeyDown={(evt) => allowNumberOnly(evt)}
												onChange={(e) => {
													const value = e.target.value.replace(/[^0-9.]/g, '');
													if (value.length <= 9 && value >= 0) {
														setLength(Number(value))
														handleCageItemChange('length', Number(value), cageIndex)
													}
												}}
												maxLength="8"
												onFocus={(e) => {
													clearError(FORM_FIELDS.CRATE_LENGTH, cageIndex)
												}}
												onBlur={(e) => {
													let errorMsg = validateFieldValue(e.target.value, t(MESSAGES.VALID_LENGTH))
													if (errorMsg) {
														handleError([FORM_FIELDS.CRATE_LENGTH], errorMsg, cageIndex)
													}
												}}
												error={lengthError ? t(lengthError, { ns: 'errors' }) : ''}
											/>
										</div>
										<div className='form-group'>
											<CommonInput
												type='text'
												label={t('COMMON.WD')}
												value={item.width === 0 ? '' : item.width}
												onKeyDown={(evt) => allowNumberOnly(evt)}
												onChange={(e) => {
													const value = e.target.value.replace(/[^0-9.]/g, '');
													if (value.length <= 8) {
														setWidth(Number(value))
														handleCageItemChange('width', Number(value), cageIndex)
													}
												}
												}
												onFocus={(e) => {
													clearError(FORM_FIELDS.CRATE_WIDTH, cageIndex)
												}}
												onBlur={(e) => {
													let errorMsg = validateFieldValue(e.target.value, t(MESSAGES.VALID_WIDTH))
													if (errorMsg) {
														handleError([FORM_FIELDS.CRATE_WIDTH], errorMsg, cageIndex)
													}
												}}
												error={widthError ? t(widthError, { ns: 'errors' }) : ''}
											/>
										</div>
										<div className='form-group input-with-dropdown'>
											<CommonInput
												type='text'
												className=''
												label={t('COMMON.HT')}
												value={item.height === 0 ? '' : item.height}
												onKeyDown={(evt) => allowNumberOnly(evt)}
												onChange={(e) => {
													const value = e.target.value.replace(/[^0-9.]/g, '');
													if (value.length <= 8) {
														setHeight(Number(value))
														handleCageItemChange('height', Number(value), cageIndex)
													}
												}
												}
												onFocus={(e) => {
													clearError(FORM_FIELDS.CRATE_HEIGHT, cageIndex)
												}}
												onBlur={(e) => {

													let errorMsg = validateFieldValue(e.target.value, t(MESSAGES.VALID_HEIGHT))
													if (errorMsg) {
														handleError([FORM_FIELDS.CRATE_HEIGHT], errorMsg, cageIndex)
													}
												}}
												error={heightError ? t(heightError, { ns: 'errors' }) : ''}
											/>
											<CommonDropDown
												id="cage-height-unit-dropdown"
												disabled={cageIndex > 0 ? true : false}
												value={dimensionUnit}
												options={DIMENSION_UNIT_SELECT_ITEMS}
												onChange={async (e) => {
													setToLocalStorage('height', e.target.value)
													setMeasurement(e.target.value)
													setDimensionUnit(e.target.value)
													handleCageItemChange('measurement', e.target.value, cageIndex)
												}}
												error={heightError}
												isNoLabel
											/>
										</div>
									</div>
									<label className="cage-dimension-label">{t('COMMON.CONTAINER_DIMENSION')}</label>
								</div>
							</div>
							<Divider />
							<MultiplePetItem
								setPetList={setPetList}
								petList={item.pets}
								// index={index}
								// item={item}
								// handleItemChange={handleItemChange}
								AlertProps={alertProps}
								shippingItem={shippingItem}
								file={file}
								setFile={setFile}
								dogBreeds={dogBreeds}
								//searchFormData={searchFormData.petList[index]}
								setArrayListDoc={setArrayListDoc}
								arrayListDoc={arrayListDoc}
								petOrder={petOrder}
								stubNose={stubNose}
								sccWarning={sccWarning}
								cageOrder={cageOrder}
								cageIndex={cageIndex}
								cageList={cageList}
								setDeletedPetIds={setDeletedPetIds}
								deletedPetIds={deletedPetIds}
								error={error}
								setError={setError}
								clearError={clearError}
								handleError={handleError}
								breedRejected={breedRejected}
								setBreedRejected={setBreedRejected}
							/>
						</div>
					)
				})}
		</>
	)
}

export default Cages;